import { reducer, initialStateBase } from './newCollection';

export const urls = {
    getConfig: '/api/config/general'
};

const initialState = Object.assign({}, initialStateBase, {
    metadataKey: 'locations'
});

export default (state = initialState, action) => {
    switch (action.type) {
        default:
            return reducer(state, action, 'CONFIG');
    }
};
